import React from "react";

const RegisteredAddress = () => {
  return <div>RegisteredAddress</div>;
};

export default RegisteredAddress;
